"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHierarchy = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M10 2.667c0-.369.299-.667.667-.667h2.666c.369 0 .667.298.667.667v2.666a.667.667 0 01-.667.667h-2.666A.667.667 0 0110 5.333V2.667zM2.667 18.666c0-.368.298-.666.667-.666H6c.368 0 .667.298.667.666v2.667A.667.667 0 016 22H3.334a.667.667 0 01-.667-.667v-2.666zM10 18.666c0-.368.299-.666.667-.666h2.667c.368 0 .666.298.666.666v2.667a.667.667 0 01-.666.667h-2.667a.667.667 0 01-.667-.667v-2.666zM17.333 18.666c0-.368.299-.666.667-.666h2.667c.368 0 .666.298.666.666v2.667a.667.667 0 01-.666.667H18a.667.667 0 01-.667-.667v-2.666z' }),
    react_1.default.createElement("path", { d: 'M11 6V4.666a1 1 0 112 0V6h-2zM11 8h2v3.666h6.333a1 1 0 011 1V16h-2v-2.334H13V16h-2v-2.334H5.666V16h-2v-3.334a1 1 0 011-1H11V8z' }))); };
exports.default = SvgHierarchy;
//# sourceMappingURL=Hierarchy.js.map